import React from 'react'
import { MainBanner, ClientsCont, ClientesCircle, ClientesCircleR} from '../Clientes/Clientes.style'

export default function Clientes (){
    return (
        <div>
            <MainBanner>
                <ClientsCont>
                
                </ClientsCont>
            </MainBanner>
        </div>
    )
}
